module.exports = __webpack_public_path__ + "static/media/open-sollicitatie.7704616b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vacatures/Overzicht/open-sollicitatie.jpg
// module id = 754
// module chunks = 0